module.exports = __webpack_public_path__ + "img/温姆3_1.ece46eb0.png";